// extracted by mini-css-extract-plugin
module.exports = {"container":"EditOperation_container__3dngc","inner":"EditOperation_inner__1xRdY","buttonRow":"EditOperation_buttonRow__uvktS","form":"EditOperation_form__30L-I"};